'use strict';
module.exports = {
	delayWarning: 40000,
	allowedAccountTypes: ['personal', 'team', 'domain'],
};
